const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const geocodeCache = new Map();

/**
 * 주소를 지오코딩하고 결과를 캐싱 (백엔드 API 호출)
 */
export async function geocodeAddress(address) {
  if (!address || address.trim() === '') {
    return null;
  }

  const cacheKey = address.trim();
  if (geocodeCache.has(cacheKey)) {
    return geocodeCache.get(cacheKey);
  }

  const pending = fetch(`${API_BASE_URL}/api/properties/geocode`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ address: cacheKey }),
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`지오코딩 API 오류: ${response.status}`);
      }
      const result = await response.json();
      if (result.success && result.data) {
        return result.data;
      }
      // 지오코딩 실패 (주소를 찾을 수 없음)
      return null;
    })
    .catch((error) => {
      console.error('지오코딩 실패:', cacheKey, error);
      return null;
    });

  geocodeCache.set(cacheKey, pending);
  return pending;
}

/**
 * 단일 매물에 lat/lng이 없으면 채워 넣음
 */
export async function ensurePropertyCoordinates(property) {
  if (!property || property.lat || property.lng) {
    return property;
  }

  const coords = await geocodeAddress(property.주소);
  if (coords) {
    return {
      ...property,
      lat: coords.lat,
      lng: coords.lng
    };
  }
  return property;
}

/**
 * 여러 매물에 대해 순차적으로 지오코딩
 */
export async function ensureCoordinatesForList(properties = [], { onProgress } = {}) {
  const result = [];
  for (let i = 0; i < properties.length; i += 1) {
    // eslint-disable-next-line no-await-in-loop
    const enriched = await ensurePropertyCoordinates(properties[i]);
    result.push(enriched);
    onProgress?.(i + 1, properties.length);
  }
  return result;
}

